import Layout from "../../../../Components/Layout";
import Instructions from "../../../../Components/EventMgt/CreateEvent/Settings/Instructions/Instructions";
import CreateEventFormTab from "../../../../Components/EventMgt/CreateEvent/CreateEventFormTab";
const InstructionsPage = () => {
    return <Layout
        BackAction="/organizer/MyEvents"
        Heading="Settings"
        TitleClassName="event-create-title"
        HeadClassName="event-page-head event-create-head"
        CreateHead
        activeMenuId="create-event"
        ExtraclassName="event-create-panel"
    >
        <div className="eventCreationFrom">
            <CreateEventFormTab Id="settings" />
            <Instructions />
        </div>
    </Layout>
}

export default InstructionsPage